<script>
export default {
  name: "BlackHoleStateRow",
  props: {
    blackHole: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isUnlocked: false,
      isPermanent: false,
      isActive: false,
      isCharged: false,
      nextChange: "",
      state: "",
    };
  },
  computed: {
    description() {
      switch (this.blackHole.description(true)) {
        case "Black Hole 1":
          return "Чёрной Дыры 1";
        case "Black Hole 2":
          return "Чёрной Дыры 2";
        default:
          return this.blackHole.description(true);
      }
    },
    id() {
      return this.blackHole.id;
    }
  },
  methods: {
    update() {
      const { blackHole } = this;
      this.isUnlocked = blackHole.isUnlocked;
      if (!this.isUnlocked) return;
      this.isPermanent = blackHole.isPermanent;
      this.isActive = blackHole.isActive;
      this.isCharged = blackHole.isCharged;
      this.nextChange = TimeSpan.fromSeconds(blackHole.timeWithPreviousActiveToNextStateChange).toStringShort();
      this.state = blackHole.displayState;
    }
  }
};
</script>

<template>
  <h3 v-if="isUnlocked">
    Состояние {{ description }}:
    <template v-if="isPermanent">
      Всегда активна
    </template>
    <template v-else-if="isActive">
      Активна ({{ nextChange }} осталось)
    </template>
    <template v-else-if="id === 2 && isCharged">
      Заряжена (Активируется с Чёрной Дырой 1, {{ nextChange }} осталось)
    </template>
    <template v-else>
      Неактивна (Активация через {{ nextChange }})
    </template>
  </h3>
</template>

<style scoped>

</style>
